/**
 * @typedef {Object} submissionPeriod
 * @prop {string} id
 * @prop {string} name Display name
 * @prop {number} dayDue Day of the month
 * @prop {Array<number>} endingMonths Periodicity
 */

/**
 * Generates a list of submission period data for a specific filing type
 * @param {Array} options Option data
 * @param {string} id Filing type ID
 * @returns {Array<submissionPeriod>}
 */
export const submissionPeriodsSetModel = (options = [], id) =>
  options
    .filter(
      ({ filingType, isAutomaticallyCreated }) => filingType.id === id && !isAutomaticallyCreated
    )
    .map(({ filingPeriod, comment, dayMonth, endingMonths, id }) => ({
      name: `${filingPeriod}${comment ? ` (${comment})` : ''}`,
      period: filingPeriod,
      dayDue: dayMonth,
      endingMonths,
      id,
    }));
